import { render, staticRenderFns } from "./agreeMent.vue?vue&type=template&id=5104b6c4&scoped=true"
import script from "./agreeMent.vue?vue&type=script&lang=js"
export * from "./agreeMent.vue?vue&type=script&lang=js"
import style0 from "./agreeMent.vue?vue&type=style&index=0&id=5104b6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104b6c4",
  null
  
)

export default component.exports